import React, { useRef, useEffect } from 'react';

import { RangeSelectorSwitch, SelectorLabel } from '../styles';

const RangeSelect = ({ handleRangeSwitch, isMini }) => {
  const toggle = useRef();

  useEffect(() => {
    isMini
      ? toggle.current.classList.add('mini-range')
      : toggle.current.classList.remove('mini-range');
  }, [isMini]);

  return (
    <div>
      <SelectorLabel htmlFor="range-switch">Cupcake Size</SelectorLabel>
      <RangeSelectorSwitch
        id="range-switch"
        onClick={handleRangeSwitch}
        ref={toggle}
      >
        <span>Regular</span>
        <span>Mini</span>
      </RangeSelectorSwitch>
    </div>
  );
};

export default RangeSelect;
